module.exports = __webpack_public_path__ + "static/media/14.521bae16.jpg";